import mixpanel from 'mixpanel-browser'

let configured = false
const isDev = import.meta.env.NODE_ENV !== 'production'

const init = () => {
  mixpanel.init('4d00244ba68601672b36af97a6d28c48', {
    debug: isDev,
    ignore_dnt: true
  })
  console.info('Initialized mixpanel')
}

// Tracks event if mixpanel is configured
export const track = (event: string, data?: any) => {
  if (!configured) {
    console.warn('Mixpanel not configured')
    return
  }

  if (!data) {
    if (isDev) {
      console.info('Tracking', { event })
    }

    mixpanel.track(event)
    return
  }

  if (isDev) {
    console.info('Tracking', { event, data })
  }

  mixpanel.track(event, data)
}

//  Registure user attributes
export const configure = data => {
  const { user, name } = data

  if (isDev) {
    console.info('Configuring mixpanel', { data })
  }

  mixpanel.register({
    user_id: user.id,
    user_name: user.name,
    env_name: name
  })
  configured = true

  track('REGISTERED')
}

export default init
